import { selectAiChatDialogState } from '../index';
import { createSelector } from '@ngrx/store';
import { AiChatState } from '../reducers/ai-chat.reducers';

export const selectMessages = createSelector(selectAiChatDialogState, (state: AiChatState) => state && state.messages);
export const selectLoading = createSelector(selectAiChatDialogState, (state: AiChatState) => state && state.loading);
export const selectMessageLoading = createSelector(selectAiChatDialogState, (state: AiChatState) => state && state.messageLoading);
export const selectError = createSelector(selectAiChatDialogState, (state: AiChatState) => state && state.error);
export const selectToken = createSelector(selectAiChatDialogState, (state: AiChatState) => state && state.token);
